export enum Endpoint {
  USER_ME = "/user/me",
  STUDENT_ME = "/student/me",
  PHOTOS = "/photos",
  TEACHER = "/teacher",
  TEACHER_ME = "/teacher/me",
  TEACHER_FINALIZE = "/teacher/finalize",
  TEACHER_LOGIN_ACCESS_TOKEN = "/teacher/login/access-token",
  CLASSES = "/classes",
  CLASSES_ARCHIVED = "/classes/archived",
  CLASSES_ID_ARCHIVE = "/classes/ID/archive",
  CLASSES_ID_UNARCHIVE = "/classes/ID/unarchive",
  DASHBOARD_OVERVIEW = "/dashboard/overview",
  DASHBOARD_TRANSACTIONS = "/dashboard/transactions",
  DASHBOARD_TODO = "/dashboard/todo",
  DASHBOARD_TODO_STOREUPDATED = "/dashboard/todo/store-updates",
  STUDENTS_SEARCH = "/students/search",
  STUDENT_TRANSACTION = "/students/ID/transactions",
  RETRIEVE_STUDENT = "/students",
  STUDENT_ID_CLASSES = "/students/ID/classes",
  STUDENT_POSSIBLE_JOBS = "/students/ID/jobs",
  STUDENT_HIRE = "/classes/CLASSID/jobs/JOBID/hire",
  STUDENT_FIRE = "/classes/CLASSID/jobs/JOBID/fire",
  STUDENT_BALANCE = "/student/balance",
  STUDENT_JOBS = "/student/jobs",
  SCHOOLS = "/schools",
  TEACHER_PASSWORD_RECOVERY = "/teacher/password-recovery",
  TEACHER_PASSWORD_RESET = "/teacher/reset-password",
  TEACHER_PASSWORD_CHANGE = "/teacher/change-password",
  COUNTRIES = "/countries",
  TEACHER_LOGIN_GOOGLE = "/teacher/login/google",
  TEACHER_LOGIN_APPLE = "/teacher/login/apple",
  TEACHER_LOGIN_CLEVER = "/teacher/login/clever",
  STUDENTS_LOGIN_CLEVER = "/students/login/clever",
  STORE_TRANSACTIONS_ACCEPT = "/store_transactions/accept",
  STORE_TRANSACTIONS_REJECT = "/store_transactions/reject",
  STORE_TRANSACTIONS_ID_ACCEPT = "/store_transactions/ID/accept",
  STORE_TRANSACTIONS_ID_REJECT = "/store_transactions/ID/reject",
  ID_HELPER_STORE_CLERK_STORE_TRANSACTIONS_ACCEPT = "/ID/helper/store-clerk/store-transactions/accept",
  ID_HELPER_STORE_CLERK_STORE_TRANSACTIONS_REJECT = "/ID/helper/store-clerk/store-transactions/reject",
  ID_HELPER_STORE_CLERK_STORE_TRANSACTIONS_STOREID_REJECT = "/ID/helper/store-clerk/store-transactions/STOREID/reject",
  CLASSES_ID_CANDIDATES = "/classes/ID/candidates",
  CLASSES_STORE_TRANSACTIONS = "/classes/ID/store_transactions",
  CLASSES_HELPER_STORE_CLERK_STORE_TRANSACTIONS = "/classes/ID/helper/store-clerk/store-transactions",
  CLASSES_ID_TRANSACTIONS = "/classes/ID/transactions",
  CLASSES_ID_HELPER_BANKER_TRANSACTIONS = "/classes/ID/helper/banker/transactions",
  CLASSES_FINES = "/classes/ID/fines",
  CLASSES_BONUSES = "/classes/ID/bonuses",
  CLASSES_EXPENSES = "/classes/ID/expenses",
  CLASSES_STORE = "/classes/ID/store",
  CLASSES_ID_HELPER_STORE_CLERK_STORE = "/classes/ID/helper/store-clerk/store",
  CLASSES_STORE_ITEMS = "/classes/ID/store/items",
  CLASSES_STORE_PURCHASE = "/classes/ID/store/purchase",
  CLASSES_ID_HELPER_STORE_CLERK_STORE_ITEMS = "classes/ID/helper/store-clerk/store/items",
  CLASSES_ID_STUDENTS = "/classes/ID/students",
  CLASSES_COPY_SETTINGS = "/classes/copy-settings",
  CLASSES_COPY_SETTINGS_CHECK = "/classes/copy-settings-check",
  CLASSES_ID_STUDENTS_SHORT = "/classes/ID/students-short",
  IMAGES = "/images",
  CLASSES_JOBS = "/classes/ID/jobs",
  STUDENTS_MATH_MANAGEMENT = "/students/math-management",
  STUDENTS_LOGIN_ACCESS_TOKEN = "/students/login/access-token",
  STUDENTS_SIGN_UP = "/students/sign-up",
  STUDENT_TRANSACTIONS_PENDING = "/student/transactions/pending",
  STUDENT_CLASSES = "/student/classes",
  STUDENT_CLASSES_ID = "/student/classes/ID",
  STUDENT_ID_STORE_ITEMS = "/student/ID/store/items",
  STUDENT_ID_STORE_PURCHASE = "/student/ID/store/purchase",
  STUDENTS_ID_BALANCE_CHARTS = "/students/ID/balance-charts",
  STUDENTS_FINALIZE = "/students/finalize",
  TRANSACTIONS_ID_BOOK = "/transactions/ID/book",
  CLASSES_ID_JOBS_CLEAN = "/classes/ID/jobs/clean",
  STUDENT_JOB_APPLICATIONS = "/student/job_applications",
  CREATE_CV = "/cv",
  STUDENT_TRANSACTIONS_BOOKED = "/student/transactions/booked",
  CLASSES_JOBS_REJECT = "/classes/CLASSID/jobs/JOBID/reject",
  JOB_APPLICATIONS = "/job_applications",
  CLASS_ID_HELPER_HR_JOB_APPLICATIONS_ID = "CLASSID/helper/hr/JOBAPPLICATIONID",
  SCHOOL_CLASSES_ID_COTEACHERS = "/school/classes/ID/co-teachers/",
  SCHOOL_CLASSES_CLASSID_COTEACHERS_TEACHERID = "/school/classes/CLASSID/co-teachers/TEACHERID",
  SCHOOL_CLASSES_ID_COTEACHERS_POSSIBLE = "/school/classes/ID/co-teachers/possible",
  STUDENTS_ID_JOBS_EXPORT = "/students/ID/jobs/export",
  STUDENTS_ID_TRANSACTIONS_EXPORT = "/students/ID/transactions/export",
  CLASSES_ID_STORE_TRANSACTIONS_EXPORT_STUDENTID = "/classes/CLASSID/store_transactions/export/STUDENTID",
  STUDENTS_ID_SAVINGS = "/students/ID/savings",
  STUDENTS_ID_GOALS = "/students/ID/goals",
  CLASSES_ID_STUDENTS_EXPORT = "/classes/ID/students/export",
  CLASSES_ID_STORE_TRANSACTIONS_EXPORT = "/classes/ID/store_transactions/export",
  CLASSES_ID_JOBS_EXPORT = "/classes/ID/jobs/export",
  SCHOOL_TEACHERS = "/school/teachers/",
  SCHOOL_TEACHERS_ID_ACCEPT = "/school/teachers/ID/accept",
  SCHOOL_TEACHERS_ID_REJECT = "/school/teachers/ID/reject",
  SCHOOL_INVITATIONS = "/school/invitations/",
  SCHOOL_INVITATIONS_ID = "/school/invitations/ID",
  TEACHER_REGISTRATION_DATA_ID = "/teacher/registration-data/ID",
  PAYMENTS_CHECKOUT_SESSIONS = "/payments/checkout/sessions",
  TEACHER_DOWNGRADE = "/teacher/downgrade",
  STUDENTS_REGISTER_GOOGLE = "/students/register/google",
  STUDENTS_LOGIN_GOOGLE = "/students/login/google",
  STUDENTS_LOGIN_APPLE = "/students/login/apple",
  STUDENTS_ASSIGN = "/students/assign-google-account",
  CLASSES_ID_STUDENTS_IMPORT = "/classes/ID/students/import",
  CLASSES_ID_STUDENTS_BALANCES_RESET = "/classes/ID/students/balances/reset",
  ASYNCTASKS_ID_STATE = "/async-tasks/ID/state",
  CLASSES_ID_CLASSSTUDENTS = "/classes/ID/class-students",
  STUDENTS_ID_ALL_TRANSACTIONS = "/students/ID/all-transactions",
  TEACHER_TRANSACTIONS = "/teacher/transactions/",
  TEACHER_TRANSACTIONS_EXPORT = "/teacher/transactions/export",
  TEACHER_TRANSACTIONS_FILTER_DATA = "/teacher/transactions/filter-data",
  TEACHER_TRANSACTIONS_IDS = "/teacher/transactions/ids",
  TEACHER_CHOOSE_SCHOOL = "/teacher/choose-school",
  STUDENT_TRANSACTIONS_ALL = "/student/transactions/all",
  STUDENT_SAVINGS = "/student/savings",
  STUDENT_ID_GOALS = "/student/ID/goals",
  STUDENT_GOALS_ID_ADD_FUNDS = "/student/goals/ID/add-funds",
  STUDENT_ID_GOALS_ID = "/student/ACCOUNTID/goals/GOALID",
  STUDENT_BALANCE_CHARTS = "/student/balance-charts",
  STUDENT_ACCOUNT_TRANSFER = "/student/account-transfer",
  STUDENT_SAVINGS_SNAPSHOT = "/student/savings-snapshot",
  STUDENT_GOALS_ID_WITHDRAW_FUNDS = "/student/goals/ID/withdraw-funds",
  STUDENT_GOALS_COMPLETED = "/student/goals/completed",

  STUDENT_ACCOUNT_TRANSACTIONS = "/student/account-transactions",
  STUDENT_SAVINGS_CHARTS_ID = "/student/savings-charts/ID",
  CLASSES_ID_STUDENT_HELPERS = "/classes/ID/student-helpers",
  CLASSES_ID_HELPER_BANKER_STUDENTS = "/classes/ID/helper/banker/students",
  CLASSES_ID_HELPER_BANKER_GROUPS = "/classes/ID/helper/banker/groups",
  CLASSES_ID_HELPER_BANKER_GROUPS_GROUPID_MEMBERS = "/classes/ID/helper/banker/groups/GROUPID/members",
  CLASSES_ID_HELPER_BANKER_GROUPS_GROUPID_TRANSACTIONS = "/classes/ID/helper/banker/groups/GROUPID/transactions",
  CLASSES_ID_HELPER_HR_STUDENTS = "/classes/ID/helper/hr/students",
  CLASSES_ID_HELPER_HR_STUDENTS_SHORT = "/classes/ID/helper/hr/students-short",
  CLASSES_ID_HELPER_HR_JOBS = "/classes/ID/helper/hr/jobs",
  CLASSES_ID_HELPER_HR_JOBS_JOBID_HIRE = "/classes/ID/helper/hr/jobs/JOBID/hire",
  CLASSES_ID_HELPER_HR_JOBS_JOBID_FIRE = "/classes/ID/helper/hr/jobs/JOBID/fire",
  CLASSES_ID_HELPER_HR_JOBS_JOBID_REJECT = "/classes/ID/helper/hr/jobs/JOBID/reject",
  ID_HELPER_HR_IMAGES = "/ID/helper/hr/images",
  TEACHER_ADMIN_SCHOOL_TRANSACTIONS = "/teacher-admin/school-transactions",
  TEACHER_ADMIN_SCHOOL_TRANSACTIONS_SCHOOL_DATA = "/teacher-admin/school-transactions/school-data",
  TEACHER_ADMIN_SCHOOL_TRANSACTIONS_IDS = "/teacher-admin/school-transactions/ids",
  TEACHER_ADMIN_TEACHERS_MANAGEMENT = "/teacher-admin/teachers-management",
  TEACHER_ADMIN_TEACHERS_MANAGEMENT_PENDING_TEACHERS = "/teacher-admin/teachers-management/pending-teachers",
  TEACHER_ADMIN_TEACHERS_MANAGEMENT_ID_SET_ADMIN = "/teacher-admin/teachers-management/ID/set-admin",
  TEACHER_ADMIN_TEACHERS_MANAGEMENT_CREATE_TEACHER = "/teacher-admin/teachers-management/create-teacher",
  TEACHER_ADMIN_BONUSES = "/teacher-admin/bonuses",
  TEACHER_ADMIN_DASHBOARD_BEHAVIORS = "/teacher-admin/dashboard/behaviors",
  TEACHER_ADMIN_DASHBOARD_BEHAVIORS_SERIES = "/teacher-admin/dashboard/behaviors/series",
  TEACHER_ADMIN_DASHBOARD_CLASS_SUMMARY = "/teacher-admin/dashboard/class-summary",
  TEACHER_ADMIN_DASHBOARD_KPI = "/teacher-admin/dashboard/kpi",
  TEACHER_ADMIN_DASHBOARD_STORE_ITEMS = "/teacher-admin/dashboard/store-items",
  TEACHER_ADMIN_DASHBOARD_TEACHERS = "/teacher-admin/dashboard/teachers",
  TEACHER_ADMIN_DASHBOARD_TEACHERS_KPI = "/teacher-admin/dashboard/teachers/kpi",
  TEACHER_ADMIN_DASHBOARD_STUDENTS = "/teacher-admin/dashboard/students",
  TEACHER_ADMIN_DASHBOARD_STUDENTS_ATTENTION = "/teacher-admin/dashboard/students/attention",
  TEACHER_ADMIN_DASHBOARD_STUDENTS_KPI = "/teacher-admin/dashboard/students/kpi",
  TEACHER_ADMIN_FINES = "/teacher-admin/fines",
  TEACHER_ADMIN_SCHOOL_TRANSACTIONS_EXPORT = "/teacher-admin/school-transactions/export",
  TEACHER_ME_INTERCOM_OPEN = "/teacher/me/intercom-open",
  STUDENT_HAS_TRANSACTIONS = "/student/has-transactions",
  EXPORT_REPORTS_ID = "/export-reports/ID",
  EXPORT_REPORTS_ID_DOWNLOAD = "/export-reports/ID/download",
  TEACHER_ADMIN_SCHOOL_SETTINGS_ATTENDANCE = "/teacher-admin/school-settings/attendance",
  CLASSES_ID_GROUPS = "/classes/CLASSID/groups",
  CLASSES_ID_GROUPS_GROUPID = "/classes/CLASSID/groups/GROUPID",
  CLASSES_ID_GROUPS_FILTER = "/classes/CLASSID/groups/filter",
  CLASSES_ID_GROUPS_IMPORT_TEMPLATE = "/classes/CLASSID/groups/import-template",
  CLASSES_ID_GROUPS_IMPORT = "/classes/CLASSID/groups/import",
  CLASSES_ID_GROUPS_EXPORT = "/classes/CLASSID/groups/export",
  CLASSES_ID_GROUPS_STORE_EXPORT = "/classes/CLASSID/groups/store-export",
  CLASSES_ID_GROUPS_GROUPID_MEMBERS = "/classes/CLASSID/groups/GROUPID/members",
  CLASSES_ID_GROUPS_GROUPID_CANDIDATES = "/classes/CLASSID/groups/GROUPID/candidates",
  CLASSES_ID_GROUPS_GROUPID_TRANSACTIONS = "/classes/CLASSID/groups/GROUPID/transactions",
  TEACHER_ADMIN_SCHOOL_GROUPS = "/teacher-admin/school/groups",
  TEACHER_ADMIN_SCHOOL_GROUPS_CANDIDATES = "/teacher-admin/school/groups/candidates",
  TEACHER_ADMIN_SCHOOL_GROUPS_IMPORT_TEMPLATE = "/teacher-admin/school/groups/import-template",
  TEACHER_ADMIN_SCHOOL_GROUPS_IMPORT = "/teacher-admin/school/groups/import",
  TEACHER_ADMIN_SCHOOL_GROUPS_EXPORT = "/teacher-admin/school/groups/export",
  TEACHER_ADMIN_SCHOOL_GROUPS_GROUPID = "/teacher-admin/school/groups/GROUPID",
  TEACHER_ADMIN_SCHOOL_GROUPS_GROUPID_MEMBERS = "/teacher-admin/school/groups/GROUPID/members",
  TEACHER_ADMIN_SCHOOL_GROUPS_GROUPID_CANDIDATES = "/teacher-admin/school/groups/GROUPID/candidates",
  TEACHER_ADMIN_SCHOOL_GROUPS_GROUPID_TRANSACTIONS = "/teacher-admin/school/groups/GROUPID/transactions",
}
